<!--
  system 模块「标准查询列表」样例：其它列表页对齐本结构（根 div + avue-crud 事件链 + publicOption）。特殊需求另扩展开。
  特殊布局（树+表、双表、弹窗内 crud）可在此基础上扩展。
-->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @search-change="searchChange" @search-reset="searchReset"
      @refresh-change="refreshChange" @current-change="currentChange" @size-change="sizeChange" @selection-change="selectionChange" @on-load="onLoad" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel" @before-open="beforeOpen">
      <template slot="menuLeft">
        <el-button
          v-if="permission['police_record_batch_process']"
          type="primary"
          size="small"
          plain
          icon="el-icon-finished"
          :disabled="selectionList.length === 0"
          @click="handleBatchAlarm"
        >批量处理</el-button>
        <el-button
          v-if="permission['police_record_one_click_process']"
          type="success"
          size="small"
          plain
          icon="el-icon-circle-check"
          @click="handleOneClickAlarm"
        >一键处理</el-button>
        <el-button
          type="default"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-edit" @click="handelDeviceAlarm('add',row)" style="color: #e37318; margin-right: 8px">
          处理
        </el-button>
      </template>
    </avue-crud>
    <dialog-reset slotShow height="40vh" top="20vh" width="50%" title="报警处理" :visible.sync="alarmHandVisible">
      <AlarmHandling v-if="alarmHandVisible" :transmitData="transmitData" @handleClose="handleClose"></AlarmHandling>
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, exportExcel } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import { getMonthStartTime, getTodayEndTime } from "@/util/date.js";
import { downloadXls } from "@/util/util";
import AlarmHandling from "./components/alarm-handling.vue";
import { mapGetters } from "vuex";

export default {
  name: "system-police-record",
  mixins: [crudMixins],
  components: {AlarmHandling},
  computed: {
    ...mapGetters(["permission"]),
  },
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      infoCardData: [], // 卡片数据
      alarmHandVisible: false,
      transmitData: {},
      exportLoading: false,
      loading:false,
      form: {},
      query: {},
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        selection: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: true,
        viewBtnText: '跟踪',
        viewTitle: "跟踪",
        dialogWidth: "1200px",
        dialogHeight: "900px",
        column: [
          {
            label: '设备分类',
            prop: 'category',
            hide: true,
            viewDisplay: true,
            search: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=category",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
          },
          {
            label: "设备名称",
            prop: "deviceName",
            width: 150,
            overHidden: true,
            search: true,
            type: "input",
            searchPlaceholder: "请输入设备名称",
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
          },
          {
            label: "设备类型",
            prop: "deviceType",
            hide: true,
            viewDisplay: true,
            align: "center",
            search: true,
            width: 120,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=base_device_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            addDisplay: true,
            editDisplay: true,
          },
          {
            label: "报警类型",
            prop: "type",
            search: true,
            width: 120,
            align: "center",
            viewDisplay: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=device_alarm_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
          },
          {
            label: "提醒类型",
            prop: "alertType",
            hide: true,
            viewDisplay: true,
            align: "center",
            search: true,
            width: 120,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=alert_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
          },
          {
            label: "处理机制",
            prop: "handlingMechanism",
            hide: true,
            viewDisplay: true,
            align: "center",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=handling_mechanism",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
          },
          {
            label: '当前数值',
            prop: 'currentValue',
            hide: true,
            viewDisplay: true,
            type: 'number',
            precision: 8,
          },
          {
            label: '阈值数值',
            prop: 'thresholdValue',
            hide: true,
            viewDisplay: true,
            type: 'number',
            precision: 8,
          },
          {
            label: '报警时间',
            prop: 'alertTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "报警状态",
            prop: "alertStatus",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=alert_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: '报警内容',
            prop: 'alarmContent',
            type: "textarea",
            span: 24,
            minRows: 3,
            search: false, // 不参与查询
            overHidden: true,
            minWidth: 200,
          },
          {
            label: '处理时间',
            prop: 'processTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '处理结果',
            prop: 'processResult',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
          },
          // {
          //   label: "处理人ID",
          //   prop: "processorId",
          //   overHidden: true,
          // },
          {
            label: "处理人",
            prop: "processorName",
            align: "center",
            width: 100,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          // {
          //   label: "创建人",
          //   prop: "createName",
          //   align: "center",
          //   width: 100,
          //   addDisplay: false,
          //   editDisplay: false,
          //   viewDisplay: true,
          // },
          // {
          //   label: '创建时间',
          //   prop: 'createTime',
          //   type: 'datetime',
          //   format: 'yyyy-MM-dd HH:mm:ss',
          //   valueFormat: 'yyyy-MM-dd HH:mm:ss',
          //   minWidth: 120,
          //   addDisplay: false,
          //   editDisplay: false,
          // },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: true,
          },
        ]
      },
    }
  },
  methods:{
    buildAlarmHandlingQuery() {
      return this.formatParams(Object.assign({}, this.defaultParams, this.query))
    },
    handleBatchAlarm() {
      if (!this.selectionList || this.selectionList.length === 0) {
        this.$message.warning('请选择需要处理的报警记录')
        return
      }
      this.transmitData = {
        type: 'batch',
        ids: this.ids
      }
      this.alarmHandVisible = true
    },
    handleOneClickAlarm() {
      const query = this.buildAlarmHandlingQuery()
      this.$confirm('确认按当前查询条件一键处理全部报警记录？', '提示', { type: 'warning' }).then(() => {
        this.transmitData = {
          type: 'oneClick',
          query
        }
        this.alarmHandVisible = true
      }).catch(() => {})
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `设备报警记录_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    // 处理
    handelDeviceAlarm (type, item) {
      this.transmitData = { type, id: item.id || null, }
      this.alarmHandVisible = true
    },
    handleClose (type) {
      this.formVisible = false
      this.alarmHandVisible = false
      // 保存并关闭后刷新列表
      this.onLoad(this.page, this.query)
    },
  },
}
</script>
<style scoped lang="scss">
</style>
